import React from 'react'
import { FullPageLoader } from '@deal/components'
import { DepartmentInfoComponent, DepartmentInfoQuery } from '#src/generated/graphql'
import { NotFound } from '#src/components/Errors'
import Chrome, { ChromeProps } from '#src/components/Chrome'
import { DepartmentSetter } from '#src/context/department'
import PageBanner from '#src/components/PageBanner'
import CategoryChatWidget from '#src/containers/CategoryChatWidget'
interface DepartmentChromeProps extends ChromeProps {
  slug: string
  footer?: boolean
  children: (data: DepartmentInfoQuery) => React.ReactNode
}

const DepartmentChrome: React.SFC<DepartmentChromeProps> = ({ children, slug, ...rest }) => (
  <Chrome {...rest}>
    <DepartmentInfoComponent variables={{ departmentSlug: slug }}>
      {({ data, loading }) => {
        if (!data || loading) {
          return <FullPageLoader />
        }

        const department = data.departmentBySlug

        if (!department) {
          return <NotFound />
        }

        return (
          <>
            <DepartmentSetter department={data.departmentBySlug} />

            {data &&
              data.departmentBySlug && (
                <CategoryChatWidget categoryId={data.departmentBySlug.topLevelCategory.id} />
              )}
            <PageBanner />
            {children(data)}
          </>
        )
      }}
    </DepartmentInfoComponent>
  </Chrome>
)

export default DepartmentChrome
